<ion-header *ngIf="showHeader">

    <ion-toolbar>
        <ion-title>{{ 'Status' | translate }}</ion-title>
    </ion-toolbar>

</ion-header>


<div class="main">
    <history [historyData]="patientDataProvider.activePatientData.transmitterHistory" ion-fixed></history>
</div>
